import React from 'react';
import { IoPerson } from 'react-icons/io5';

const OtherTextChatContainer = ({ message, time, senderName, senderProfileImageUrl, showProfile = true, showTime = true }) => {
  const formatTime = (timeString) => {
    if (!timeString) return '';
    const date = new Date(timeString);
    return date.toLocaleTimeString('ko-KR', { 
      hour: 'numeric', 
      minute: '2-digit',
      hour12: true
    });
  };

  const isMasked = message === '차단된 밥친구입니다' || message === '차단된 사용자입니다';

  return (
    <div className="flex justify-start mb-2">
      <div className="flex items-start" style={{ maxWidth: '70%' }}>
        {/* 프로필 이미지 */}
        <div className="mr-3 flex-shrink-0">
          {showProfile ? (
            senderProfileImageUrl ? (
              <img 
                src={senderProfileImageUrl} 
                alt={senderName}
                className="w-8 h-8 rounded-full object-cover"
              />
            ) : (
              <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center">
                <IoPerson size={16} className="text-gray-600" />
              </div>
            )
          ) : (
            <div className="w-8 h-8"></div>
          )}
        </div>
        
        {/* 메시지 컨테이너 */}
        <div className="flex-1">
          {/* 발신자 이름 (프로필이 보일 때만) */}
          {showProfile && senderName && (
            <div className="text-xs text-gray-600 mb-1 ml-1">
              {senderName}
            </div>
          )}
          
          <div className="flex items-end">
            {/* 말풍선 */}
            <div className={`bg-white border ${isMasked ? 'border-gray-100' : 'border-gray-200'} rounded-2xl px-4 py-2 min-w-0`}>
              <p className={`text-sm whitespace-pre-wrap break-all ${isMasked ? 'text-gray-400' : 'text-gray-900'}`}>{message}</p>
            </div>
            
            {/* 시간 */}
            {showTime && (
              <div className="ml-2 text-xs text-gray-500">
                {formatTime(time)}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtherTextChatContainer; 